<div class="location-header">
  <button (click)="handleClick()">
    <img src="/assets/close-cms.svg" alt="" *ngIf="icon === 'close'" />
    <img src="/assets/back-arrow-big.svg" alt="" *ngIf="icon === 'back'" />
  </button>
  <h1>{{ title }}</h1>
</div>
